import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext.tsx';
import { useAuth } from '../contexts/AuthContext.tsx';
import { APP_CONFIG } from '../constants/appConfig.ts';

const Sidebar = () => {
  // location 훅만 사용
  // const navigate = useNavigate(); // 사용하지 않음
  const location = useLocation();
  const { lastSaveTime } = useAppContext();
  const { user, hasPermission } = useAuth();
    
  // 페이지 이동 함수
  const navigateTo = (path: string) => {
    console.log("Navigating to:", path);
    // URL을 직접 변경하는 방식 추가
    window.location.href = path;
    // navigate 함수도 유지
    // navigate(path);
  };

  return (
    <div className="bg-blue-800 text-white w-full h-full flex flex-col">
      <div className="p-4 border-b border-blue-700">
        <h2 className="text-xl font-semibold">{APP_CONFIG.FULL_APP_NAME}</h2>
      </div>
      
      <nav className="flex-1 overflow-y-auto py-4">
        <ul className="space-y-2 px-2">
          {user && hasPermission('view_performance') && (
            <li>
              <div
                onClick={() => navigateTo('/')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${(location.pathname === '/' || location.pathname === '/team-performance') ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
                팀 성과 관리
              </div>
            </li>
          )}
          {user && hasPermission('view_payroll') && (
            <li>
              <div
                onClick={() => navigateTo('/payroll')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/payroll' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                급여 관리
              </div>
            </li>
          )}
          {user && hasPermission('view_sales') && (
            <li>
              <div
                onClick={() => navigateTo('/actual-sales')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/actual-sales' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                실제매출 자동화
              </div>
            </li>
          )}
          {user && hasPermission('view_daily_report') && (
            <li>
              <div
                onClick={() => navigateTo('/daily-report')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/daily-report' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                데일리 리포트
              </div>
            </li>
          )}
          {user && hasPermission('view_annual_leave') && (
            <li>
              <div
                onClick={() => navigateTo('/annual-leave')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/annual-leave' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                연차 관리
              </div>
            </li>
          )}
          {user && hasPermission('manage_users') && (
            <li>
              <div
                onClick={() => navigateTo('/user-management')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/user-management' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-2.25" />
                </svg>
                사용자 관리
              </div>
            </li>
          )}
          {user && hasPermission('view_settings') && (
            <li>
              <div
                onClick={() => navigateTo('/settings')}
                className={`flex items-center p-2 rounded-lg hover:bg-blue-700 cursor-pointer ${location.pathname === '/settings' ? 'bg-blue-700 text-white' : ''}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                설정
              </div>
            </li>
          )}
        </ul>
      </nav>
      
      {lastSaveTime && (
        <div className="p-4 text-xs text-blue-300 border-t border-blue-700">
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            마지막 저장: {lastSaveTime}
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;